var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgQbCashBank = function SvgQbCashBank(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 21,
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7339 4.09043H16.5646C19.7759 4.09043 22.3791 6.76114 22.3791 10.0556C22.3791 13.35 19.7759 16.0208 16.5646 16.0208H12.4088V0C13.6015 0 14.5685 0.99193 14.5685 2.21565V13.8051H16.5646C18.5799 13.8051 20.2194 12.1231 20.2194 10.0556C20.2194 7.98812 18.5799 6.30607 16.5646 6.30607H15.7339V4.09043ZM6.59375 16.02C3.38244 16.02 0.779175 13.3492 0.779175 10.0548C0.779175 6.76039 3.38244 4.08961 6.59375 4.08961H10.7495V20.1104C9.55678 20.1104 8.58984 19.1184 8.58984 17.8947V6.30526H6.59375C4.57845 6.30526 2.93887 7.98725 2.93887 10.0548C2.93887 12.1223 4.57845 13.8043 6.59375 13.8043H7.4244V16.02H6.59375Z",
    fill: "black",
    fillOpacity: 0.85
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgQbCashBank);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "qb-cash-bank.141336028ba7d30aea235a71bb9b4720.svg";